<script>
    import { store, store_offer } from '../Store.svelte';
    import { env } from '../Environment.svelte';

    $store.requestedAddress = env.cleanstore.requestedAddress;
    $store.personalDetails = env.cleanstore.personalDetails;
    $store.requestedServices = env.cleanstore.requestedServices;
    $store_offer.loadedOffer = env.cleanstore_offer.loadedOffer;
    $store.purchaseStatus = env.cleanstore.purchaseStatus;
</script>

<offer>{JSON.stringify($store_offer.loadedOffer)}</offer>
<postalCode>{$store.requestedAddress.postalCode}</postalCode>
<addressId>{$store.requestedAddress.addressId}</addressId>
<addressString>{$store.requestedAddress.addressString}</addressString>
